/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '@sede-x/shell-ds-react-base';
import * as Styled from '../Icon.styles';
const HomeBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="m14.252 3.87-.39-.31a3 3 0 0 0-3.724.001l-.392.306L2.194 9.85a.5.5 0 0 0-.09.692l.626.833a.5.5 0 0 0 .712.09L4 11.02v7.068a3 3 0 0 0 3 3H17.001a3 3 0 0 0 3-3v-7.068l.557.446a.5.5 0 0 0 .712-.09l.625-.834a.5.5 0 0 0-.089-.692L18 6.835V4.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v.75l-1.746-1.383-.002.003ZM6 9.87v8.216a1 1 0 0 0 1 1h3V14.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4.587h3a1 1 0 0 0 1-1V9.87a1 1 0 0 0-.22-.625l-5.159-4.117a1 1 0 0 0-1.241 0L6.222 9.244A1 1 0 0 0 6 9.87Z" /></svg>);
const Home = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={HomeBase} {...rest} ref={ref} />);
export default Home;